










  import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
  export default class MainIcon extends Vue {
  @Prop(String) readonly url!: string
  }
